import { render, staticRenderFns } from "./SellersWithSales.vue?vue&type=template&id=664651fc"
import script from "./SellersWithSales.vue?vue&type=script&lang=js"
export * from "./SellersWithSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports